import {Button} from "parts";

export function Back(props) {
  return (
    <Button variant={'secondary'} size={'md'} style={{padding: 8}} {...props}>
      <img src={'/static/img/icon/back2.svg'} alt="" width={16} height={16}/>
    </Button>
  )
}
